if(!customElements.get('header-bar')) {
  class HeaderBar extends HTMLElement {
    constructor() {
      super();

      this.menuOpen = false;
      this.isDesktop = window.matchMedia('(min-width: 1200px)');

      this.elMenuToggle = this.querySelector('[data-menu-toggle]');
      this.elMenu = this.querySelector('[data-menu]');
      this.elLinks = this.querySelectorAll('[data-header-link]');
      this.elFocusItems = this.elMenu.querySelectorAll('button, a, [href], input, select, textarea, [tabindex="0"]');

      this.setHeaderVisibility();
      this.setScrolledState();
      window.addEventListener('resize', this.setHeaderVisibility.bind(this));
    }

    connectedCallback() {
      document.addEventListener('readystatechange', () => {
        if (document.readyState === "complete") {
          this.elSearchToggle = this.querySelector('[data-search-toggle]');
          this.elSearchModal = document.getElementById('search-drawer');
          this.elSearchToggle.addEventListener('click', this.toggleSearchDrawer.bind(this))

          this.elMenuToggle.addEventListener('click', () => {
            this.menuOpen = !this.menuOpen;
            this.toggleHeaderMenu();
          });
        }
      })
    }

    toggleHeaderMenu() {
      this.elMenu.setAttribute('tabindex', this.menuOpen ? '0' : '-1');
      this.elMenuToggle.setAttribute('aria-expanded', this.menuOpen);
      this.elSearchModal.setAttribute('open', false);

      if(this.menuOpen) {
        this.elMenu.toggleAttribute('hidden', !this.menuOpen);
        this.elMenuToggle.innerHTML = 'Close';
        setTimeout(() => {
          document.body.classList.add('overflow-hidden');
          this.elMenu.classList.add('open');
          this.elMenuToggle.classList.add('active');
          this.elFocusItems[0] && this.elFocusItems[0].focus({ preventScroll: true });
        }, 100);
      } else {
        this.elMenuToggle.focus({ preventScroll: true });
        this.elMenu.classList.remove('open');
        this.elMenuToggle.classList.remove('active');
        this.elMenuToggle.innerHTML = 'Menu';
        document.body.classList.remove('overflow-hidden');
        setTimeout(() => {
          this.elMenu.toggleAttribute('hidden', !this.menuOpen);
        }, 300);
      }
    }
    
    toggleSearchDrawer() {
      if(!this.elSearchModal) return;
      const searchOpen = this.elSearchModal.getAttribute('open') == 'true';
      const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
      if(!isDesktop && this.menuOpen) {
        this.menuOpen = false;
        this.toggleHeaderMenu();
      }
      this.elSearchModal.setAttribute('open', !searchOpen);
      this.elSearchModal.querySelector('input').focus({ preventScroll: true });
    }

    setHeaderVisibility() {
      let isDesktop = window.matchMedia('(min-width: 1024px)').matches;
      if(isDesktop !== this.isDesktop) {
        this.isDesktop = isDesktop;
        this.elMenu.setAttribute('tabindex', isDesktop ? '0' : '-1');
        this.elMenu.toggleAttribute('hidden', !isDesktop);
        this.elMenu.classList.remove('open');
      }
    }

    setScrolledState() {
      const elObserver = this.parentNode.querySelector('[data-observer]');
      const observer = new IntersectionObserver(entries => {
        entries.forEach(({ isIntersecting }) => {        
          isIntersecting ? this.classList.remove('scrolled') : this.classList.add('scrolled');
        })
      });
  
      observer.observe(elObserver);
    }
  }

  customElements.define('header-bar', HeaderBar);
}